// extracted by mini-css-extract-plugin
export var projectWrapper = "project-module--project-wrapper--Our6-";
export var homeLink = "project-module--home-link--oaPPF";